import { Component, Input } from '@angular/core';
import { HistoryEntry } from './new-internet.model';

@Component({
    selector: 'app-ni-history',
    templateUrl: './history.component.html',
    styleUrls: ['./history.component.scss'],
    standalone: false
})
export class HistoryComponent {
  @Input() history: HistoryEntry[] = [];
  @Input() search = '';

  get visible(): HistoryEntry[] {
    const q = this.search.trim().toLowerCase();
    return [...this.history]
      .filter(h => !q
        || h.title.toLowerCase().includes(q)
        || h.source.toLowerCase().includes(q))
      .sort((a, b) => b.viewedAt - a.viewedAt);
  }
}
